import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { LoggerPublicOverview } from './types';

export type LoggerAccess = {
  barcode: string;
  code: string;
  overview: LoggerPublicOverview;
};

type LoggerAccessSliceType = {
  access: LoggerAccess | null
}

export const loggerAccessSlice = createSlice({
  name: 'loggerAccess',
  initialState: { access: null } as LoggerAccessSliceType,
  reducers: {
    grant: (state, { payload }: PayloadAction<LoggerAccess>) => { state.access = payload; },
    updateOverview: (state, { payload }: PayloadAction<LoggerPublicOverview>) => {
      if (state.access) state.access.overview = payload;
    },
    revoke: (state) => { state.access = null; }
  }
});

export const actions = loggerAccessSlice.actions;

export const selectors = {
  getLoggerAccess: (barcode: string) => (state: RootState) => {
    const access = state.loggerAccess.access;
    return access && access.barcode === barcode ? access : null;
  }
};
